import styled from 'styled-components';
import {BsPeople, BsDashCircle, BsPlusCircle, BsXCircle} from 'react-icons/bs';

export const Users = styled(BsPeople)`
`;

export const Collapse = styled(BsDashCircle)`
  color: #28a745;
`;

export const Expand = styled(BsPlusCircle)`
  color: #28a745;
`;

export const Disconnect = styled(BsXCircle)`
  color: #dc3545;
`;
